import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { useNavigate } from 'react-router';

import { uiActions } from '../../store/ui-slice';
import { form4FetchCatalogs } from '../../store/catalogs-actions';
import { form4Transaction } from '../../store/forms/form4-actions';
import MoralPerson from '../formSections/MoralPerson';
import PhysicalPerson from '../formSections/PhysicalPerson';
import PersonType from '../formSections/PersonType';
import Button from '../commons/Button';

import { doNavigation } from '../../utils/helper-functions';
import { makeValuesForm4 } from '../../utils/form';
import { FORM4_VALIDATION_SCHEMA } from '../../constants/validation-schemas';
import { PHYSICAL_PERSON_VALUE, MORAL_PERSON_VALUE } from '../../constants/constants';

const Form4 = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.appConfig.appToken);
  const navigate = useNavigate();
  const currentStep = useSelector((state) => state.appConfig.quoterCurrentStep);
  const storePersonType = useSelector((state) => state.form4.data.personType);
  const form4State = useSelector((state) => state.form4.data);

  // Person type 1 = Physical, person type 2 = Moral (see constants files)
  const [personType, setPersonType] = useState(storePersonType);

  const submitHandler = (values) => {
    const payload = makeValuesForm4(values);
    dispatch(form4Transaction(payload, currentStep, navigate));
  };

  const navigationHandler = (direction) => {
    doNavigation(currentStep, direction, navigate, dispatch, uiActions, true);
  };

  const onChangePersonType = (value) => {
    setPersonType(value);
  };

  const splitStoreValues = (values) => {
    let splitValues = {};
    Object.keys(values).forEach((key) => {
      splitValues = { ...splitValues, ...values[key] };
    });
    splitValues.personType = values.personType;

    return splitValues;
  };

  useEffect(() => {
    if (token) {
      dispatch(form4FetchCatalogs(token));
    }
  }, [dispatch, token]);

  return (
    <Formik
      onSubmit={submitHandler}
      enableReinitialize
      initialValues={splitStoreValues(form4State)}
      validateOnMount={!form4State.wasValidatedBefore}
      validationSchema={Yup.object().shape(FORM4_VALIDATION_SCHEMA)}>
      {({ isValid }) => {
        return (
          <Form className="quoter-form">
            <h2 className="form-title">
              ¡Muy pronto quedarás asegurado!
            </h2>
            <p className="form-subtitle text-center">
              Ingresa tus datos personales para emitir tu póliza.
            </p>
            <PersonType onChange={onChangePersonType} isInsuredPerson />
            {personType === PHYSICAL_PERSON_VALUE && <PhysicalPerson isInsuredPerson />}
            {personType === MORAL_PERSON_VALUE && <MoralPerson isInsuredPerson />}
            <div className="form-buttons">
              <Button
                onClick={() => navigationHandler('backward')}
                type="button"
                label="Regresar"
                buttonClasses="-secondary"
                iconPosition="before"
                iconClasses="arrow-left" />
              <Button
                type="submit"
                disabled={!isValid}
                label="Continuar"
                iconClasses="arrow-right" />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Form4;
